import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { lineHeight, theme, toRem } from 'design';

const StyledLink = styled(Link)`
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  font-size: ${toRem(theme.font.size.sm)};
  line-height: ${lineHeight(theme.font.size.sm)};
  color: ${theme.color.primary[500]};
  text-decoration-line: underline;

  &:visited,
  &:active {
    color: ${theme.color.primary[500]};
  }
`;

export default StyledLink;
